import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilsService } from '../_services/utils.service';
import { environment } from 'src/environments/environment.prod';

@Injectable()
export class ZipCodeValidator {

  debouncer: any;

  constructor(public utilsService : UtilsService){

  }

  checkZipCode(control: FormControl): any {

    clearTimeout(this.debouncer);

    return new Promise(resolve => {

      this.debouncer = setTimeout(() => {

        this.utilsService.getProvince(control.value).subscribe((res) => {
            resolve(null);
        }, (err) => {
          resolve({'zipCodeInvalid': true});
        });

      }, environment.CHECK_TIMEOUT);      

    });
  }
}